import Vue from 'vue';
const { $gettext } = Vue.prototype;
import Storage from '@/utils/storage';
import {

} from '../mutation-types';
import MediaService from '@/services/MediaService';
const media = {
  state: () => ({
   }),
   getters: {
  },
   mutations: {
	 },
  actions: {
		async getListMedia({state, rootState},{type, page}) {
			return await MediaService.getMediaListOfCourse(
				{
					courseId: rootState.golfcourse.courseDetail.id,
					filter_type: type,
          filter_entityName: 'post',
					sort_desc: 'createdDate',
					page
				}
			)
		},
		async getMediaDetailWithCourse({}, id) {
			return await MediaService.getMediaDetail(
				{
					id,
					courseDetail: true
				}
			)
		},
		async getMediaDetail({}, id) {
			return await MediaService.getMediaDetail({ id })
		}
	}
}

export default media;